import { defineMessages } from 'react-intl';

export default defineMessages({
  checklistStepButtonTitle: {
    id: 'app.containers.AnnouncementSteps.ChecklistStep.buttonTitle',
    defaultMessage: 'Concluir checklist',
  },
  statusListChecklistStepTitle: {
    id: 'app.containers.AnnouncementSteps.ChecklistStep.Checklist.title',
    defaultMessage: 'Checklist',
  },
  statusListChecklistStepDescription: {
    id: 'app.containers.AnnouncementSteps.ChecklistStep.Checklist.description',
    defaultMessage: 'Avaliação do imóvel',
  },
  photosphereStepButtonTitle: {
    id: 'app.containers.AnnouncementSteps.PhotosphereStep.buttonTitle',
    defaultMessage: 'Concluir sessão e publicar o anúncio',
  },
  photosphereStepButtonSave: {
    id: 'app.containers.AnnouncementSteps.PhotosphereStep.buttonSave',
    defaultMessage: 'Salvar descrição e ordem das Fotos 360',
  },
  statusListPhotosphereStepTitle: {
    id: 'app.containers.AnnouncementSteps.StatusList.PhotosphereStep.title',
    defaultMessage: 'Envio de fotos 360',
  },
  statusListVideoStepTitle: {
    id: 'app.containers.AnnouncementSteps.StatusList.VideoStep.title',
    defaultMessage: 'Envio do video',
  },
  videoStepButtonTitle: {
    id: 'app.containers.AnnouncementSteps.VideoStep.buttonTitle',
    defaultMessage: 'Enviar link',
  },
  statusListPhotoStepTitle: {
    id: 'app.containers.AnnouncementSteps.StatusList.PhotoStep.title',
    defaultMessage: 'Envio de fotos',
  },
  statusListPhotoStepDescription: {
    id: 'app.containers.AnnouncementSteps.StatusList.PhotoStep.description',
    defaultMessage: 'Envie as fotos do imóvel',
  },
  photoStepButtonSave: {
    id: 'app.containers.AnnouncementSteps.PhotoStep.buttonSave',
    defaultMessage: 'Salvar fotos',
  },
  statusListPhotosStepTitle: {
    id: 'app.containers.AnnouncementSteps.StatusList.Photos.title',
    defaultMessage: 'Envio de fotos',
  },
  statusListPhotosStepDescription: {
    id: 'app.containers.AnnouncementSteps.StatusList.Photos.description',
    defaultMessage: 'Envie as fotos do imóvel',
  },
  photosStepButtonSave: {
    id: 'app.containers.AnnouncementSteps.Photos.buttonSave',
    defaultMessage: 'Enviar fotos',
  },
  mobileDialogContent: {
    id: 'app.containers.AnnouncementSteps.MobileDialog.mobileDialogFirstParagraph',
    defaultMessage: 'Essa etapa foi criada para ser usada em um computador. ' +
      'Acesse, com a sua conta do {companyName}, o link abaixo para uma experiência melhor: ',
  },
  mobileDialogLink: {
    id: 'app.containers.AnnouncementSteps.MobileDialog.mobileDialogLink',
    defaultMessage: 'fotografo.quintoandar.com.br',
  },
});
